import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
/**
 * @function linkCard
 * @function getProfileByPersonalId
 */
export default {
    config: function () {
        return Vue.bzbsConfig;
    },
    /**
     * @param {object} params from '@/module/Supplementary/model/SupplementaryModel.js';
     */
    linkCard: function (params) {
        var url = this.config().bzbsModuleUrl + "/web/linkcard";
        return BzbsApi.connectBzbsPost(url, null, params);
    },
    /**
    * @param {object} params from '@/module/Supplementary/model/ProfileModel.js';
    */
    getProfileById: function (personalId) {
        var url = `${this.config().bzbsModuleUrl}/web/profile?personalId=${personalId}`;
        return BzbsApi.connectBzbsGet(url, null);
    },
}
